import * as React from 'react';
/**
 *
 * Original name: pin
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=3685%3A395
 *
 */
export const PinPictogram = (props) => (React.createElement("svg", { viewBox: "0 0 64 64", fill: "none", ...props },
    React.createElement("path", { d: "m51.214 22.029-9.343-9.344a6.007 6.007 0 0 0-8.485 0L28.8 17.271l3 3-5.672 5.671-1.843-1.842a8.009 8.009 0 0 0-11.313 0L8.8 28.271l12.05 12.05-10.264 10.265 2.828 2.828L23.678 43.15 35.629 55.1l4.171-4.172a8.009 8.009 0 0 0 0-11.313l-1.843-1.843 5.672-5.672 3 3 4.585-4.585a6 6 0 0 0 0-8.485v-.001Zm-2.828 5.657-1.757 1.757-3-3L32.3 37.771l4.671 4.671a4.007 4.007 0 0 1 0 5.657l-1.343 1.343-21.171-21.171 1.343-1.343a4.005 4.005 0 0 1 5.657 0l4.671 4.672 11.329-11.329-3-3 1.757-1.757a2 2 0 0 1 2.829 0l9.343 9.343a2 2 0 0 1 0 2.828v.001Z", fill: "currentColor" })));
